import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import APIS from "../../constant/Endpoint";
import TrashIcon from "../../Icons/TrashIcon";
import DataTable from "../Reusable/NestedDatatable";
import TableActionButton from "../Reusable/TableActionButton";

export default (props: any) => {
  const { handleDelete, isLoading } = props;

  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "code",
      header: "Code",
      cell: ({ row, getValue }: any) => {
        return (
          <p
            style={{
              paddingLeft: `${row.depth * 20}px`,
            }}
          >
            {getValue()}
          </p>
        );
      },
    },
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ row, getValue }: any) => {
        const hasChildren = row.subRows?.length > 0;
        return (
          <div
            style={{
              paddingLeft: `${row.depth * 20}px`,
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            {hasChildren && (
              <button
                onClick={row.getToggleExpandedHandler()}
                className={tw`focus:outline-none`}
              >
                {row.getIsExpanded() ? "▼" : "▶"}
              </button>
            )}
            <p>{getValue()}</p>
          </div>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`flex gap-x-4 items-center`}>
            <TableActionButton />
            <button
              className={tw`focus:outline-none`}
              type="button"
              disabled={isLoading || false}
              onClick={() => handleDelete(getValue())}
            >
              <TrashIcon color={"var(--primary)"} />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className={tw`space-y-2 mt-4`}>
      <DataTable
        columns={columns}
        queryKey={"charts-of-account"}
        url={`${APIS.COA}chart/`}
        tableName={"charts-of-account"}
        params={
          {
            // parent__isnull: true,
          }
        }
      />
    </div>
  );
};
